var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalBlogs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.20667 17.7778L10 21.5711L13.7933 17.7778H17.7778C19.0033 17.7778 20 16.7811 20 15.5556V2.22222C20 0.996667 19.0033 0 17.7778 0H2.22222C0.996667 0 0 0.996667 0 2.22222V15.5556C0 16.7811 0.996667 17.7778 2.22222 17.7778H6.20667ZM2.22222 2.22222H17.7778V15.5556H12.8733L10 18.4289L7.12667 15.5556H2.22222V2.22222Z",
    fill: "#2795AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5322 5.79894L5.0022 11.3201V13.3189H7.0022L12.53 7.79783L10.5322 5.79894ZM12.9978 3.33228L14.9978 5.33228L13.4755 6.8545L11.4755 4.85561L12.9978 3.33228Z",
    fill: "#2795AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalBlogs);
export default __webpack_public_path__ + "static/media/total-blogs.54cb8a354e59b1268bf4239a3451d02d.svg";
export { ForwardRef as ReactComponent };